import Fetcher from '../../common/util/Fetcher';
import { QUIZ_SESSIONS_FETCH_CALL, QUIZ_SESSION_FETCH_CALL, QUIZ_SESSION_REOPEN_CALL, QUIZ_SESSION_AUTOSUBMIT_CALL } from '@instructure/quiz-common';
import { handleQuizSessionResponse, handleQuizSessionsResponse } from '../../common/api/callHandlers';
export function getQuizSessions(quizId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var url = "/api/quizzes/".concat(quizId, "/quiz_sessions");
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: QUIZ_SESSIONS_FETCH_CALL
    });
    return fetcher.get(url, params).then(function (response) {
      dispatch(handleQuizSessionsResponse(response));
    });
  };
}
export function getQuizSession(quizSessionId) {
  var url = "/api/quiz_sessions/".concat(quizSessionId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: QUIZ_SESSION_FETCH_CALL
    });
    return fetcher.get(url).then(function (response) {
      dispatch(handleQuizSessionResponse(response));
    });
  };
}
export function reopenQuizSession(quizSessionId) {
  var url = "/api/quiz_sessions/".concat(quizSessionId, "/reopen");
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: QUIZ_SESSION_REOPEN_CALL
    });
    return fetcher.post(url).then(function (response) {
      dispatch(handleQuizSessionResponse(response));
    });
  };
}
export function submitOutstandingQuizSession(quizSessionId) {
  var url = "/api/quiz_sessions/".concat(quizSessionId, "/autosubmit");
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: QUIZ_SESSION_AUTOSUBMIT_CALL
    });
    return fetcher.post(url).then(function (response) {
      dispatch(handleQuizSessionResponse(response));
    });
  };
}